import React from 'react';
import ContentLayout, { Prose } from '../components/ContentLayout';
import CopyrightNotice from '../components/CopyrightNotice';

const S = ({ title, children }) => (
  <section className="mt-8">
    <h2 className="font-serif-display text-2xl md:text-3xl text-burgundy mb-3">{title}</h2>
    <Prose>{children}</Prose>
  </section>
);

const PrivacyPage = () => (
  <ContentLayout
    testid="page-privacy"
    eyebrow="Legal"
    titleTop="Privacy"
    titleItalic="Policy"
    intro="Your trust matters to us. This policy explains what information we collect, how we use it, and the choices you have regarding your personal data."
  >
    <S title="1. Information We Collect">
      <p>We collect information you provide directly — such as your name, email, phone number and address when you create an account, book a program, become a member, or make a donation. We also collect limited technical data (such as device and usage information) to improve the website.</p>
    </S>
    <S title="2. How We Use Your Information">
      <p>We use your information to provide and manage your account and bookings, process payments and donations, send confirmations and important updates, respond to inquiries, and improve our services. We do not sell your personal data.</p>
    </S>
    <S title="3. Payments">
      <p>Payments are processed by trusted third-party providers (such as Stripe). Your full payment card details are handled directly by these providers and are never stored on our servers.</p>
    </S>
    <S title="4. Cookies">
      <p>We use cookies and similar technologies to keep you signed in, remember your preferences, and understand how the site is used. You can control cookies through your browser settings.</p>
    </S>
    <S title="5. Sharing of Information">
      <p>We share information only with service providers who help us operate the website and process payments, or when required by law. These providers are bound to protect your data.</p>
    </S>
    <S title="6. Data Security">
      <p>We take reasonable technical and organizational measures to protect your information. However, no method of transmission over the internet is completely secure.</p>
    </S>
    <S title="7. Your Rights">
      <p>You may access, update or request deletion of your personal information, and opt out of non-essential communications, by managing your account or contacting us.</p>
    </S>
    <S title="8. Children’s Privacy">
      <p>Our services are not directed to children under 13, and we do not knowingly collect their personal information.</p>
    </S>
    <S title="9. Changes to This Policy">
      <p>We may update this Privacy Policy periodically. The latest version will always be available on this page.</p>
    </S>
    <S title="10. Copyright & Content Removal">
      <CopyrightNotice />
    </S>
    <S title="11. Contact">
      <p>For privacy questions or requests, please reach us via the <a href="/contacts" className="text-rose-italic hover:underline">Contact Us</a> page or email friendsdesk@oshouniversal.org.</p>
    </S>
  </ContentLayout>
);

export default PrivacyPage;
